module.exports = __webpack_public_path__ + "img/4.e65805b7.png";